//import styled from 'styled-components';
import Head from 'next/head';
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { Query } from 'react-apollo';
import getPracticalInfo from '../../src/apollo/graphql/info/getPracticalInfo';
import { withI18N } from '../../src/hoc/index';

import Breadcrumb from '../../src/components/Breadcrumb';
import { Container } from '../../src/components/Grid';
import Header from '../../src/components/Header';
import { Main, Page, Push } from '../../src/components/Layout';
import Watermark from '../../src/components/Parallax/Watermark';
import Access from './Access';
import Info from './Info';
import PushParking from './PushParking';
import InstagramFeed from '../../src/components/Feed/InstagramFeed';
// Partials
import Services from './Services';
import createContext from '../../src/utils/format/createContext';

class InfosPage extends React.PureComponent {
  render() {
    const { t, i18n } = this.props;

    return (
      <Page information>
        <Head>
          <title key="title">Grand Hôtel-Dieu</title>
        </Head>
        <Query query={getPracticalInfo} context={createContext(i18n.language)}>
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPracticalInfo) {
              const {
                detail,
                services,
                accesses,
                parkings,
                access_desktop,
                access_mobile,
                visual_desktop,
                visual_mobile,
                push_bg_desktop,
                push_bg_mobile
              } = data.getPracticalInfo;
              const hours = JSON.parse(data.getPracticalInfo.tt_hours);

              return (
                <React.Fragment>
                  <Header
                    title={detail.title}
                    image={data.getPracticalInfo.header_desktop}
                    imageMobile={data.getPracticalInfo.header_mobile}
                  />
                  <Main>
                    <Container>
                      <Breadcrumb
                        items={[
                          { href: '/', label: t('common:nav.tabs.home') },
                          { label: detail.title }
                        ]}
                      />
                    </Container>
                    <Info
                      data={detail}
                      hours={hours}
                      img={visual_desktop}
                      imgMobile={visual_mobile}
                    />
                    <Services data={services} />
                    <Access
                      data={accesses}
                      img={access_desktop}
                      imgMobile={access_mobile}
                    />
                    <PushParking data={parkings} />
                    <InstagramFeed title={detail?.section_instagram_title} />
                  </Main>
                </React.Fragment>
              );
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(InfosPage);
